module.exports = __webpack_public_path__ + "img/CRC1_Fibroblasts.4b635f7c.png";